import { render, staticRenderFns } from "./app-table.vue?vue&type=template&id=a5112c6e&scoped=true"
import script from "./app-table.vue?vue&type=script&lang=js"
export * from "./app-table.vue?vue&type=script&lang=js"
import style0 from "./app-table.vue?vue&type=style&index=0&id=a5112c6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5112c6e",
  null
  
)

export default component.exports